import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Grid from '@mui/material/Unstable_Grid2';
import { Button, TextField, Alert, Stack, Typography } from '@mui/material';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FunZoneLogo from '../components/Login/FunZoneLogo';
import useUser from '../../hooks/useUser';
import { useAuth } from '../../context/authContext';
import { getLoginFormGridSx } from '../../util/loginFormGridSx';
import { viewRootTextPrimarySx } from '../../util/chartTheme';

function RequestPasswordReset() {
  const [input, setInput] = useState('');
  const { isLoading, error, successMessage, requestPasswordReset } = useUser();
  const { logout, isLoggedIn } = useAuth();

  // Auto-logout when accessing password reset page
  useEffect(() => {
    if (isLoggedIn) {
      logout();
    }
  }, [isLoggedIn, logout]);

  async function handleSubmit(event) {
    event.preventDefault();

    if (!input.trim()) {
      return;
    }

    await requestPasswordReset(input.trim());
  }

  function translateSuccessMessage(success) {
    let successMessage = success;
    if (
      successMessage ===
      'If a user with this information exists, a password reset email will be sent.'
    )
      successMessage =
        'Falls ein Benutzer mit diesen Informationen existiert, wird eine E-Mail zum Zurücksetzen des Passworts gesendet.';
    return successMessage;
  }

  return (
    <Grid
      xs={12}
      container
      rowSpacing={2}
      sx={theme => ({ ...viewRootTextPrimarySx, ...getLoginFormGridSx(theme) })}
      width='95%'
    >
      <form onSubmit={handleSubmit} style={{ width: '100%' }}>
        {/* LOGO */}
        <Grid xs={12}>
          <FunZoneLogo />
        </Grid>

        {!successMessage && !error && (
          <>
            {/* TITLE */}
            <Grid xs={12}>
              <Typography variant='h5' component='h2' sx={{ textAlign: 'center', mb: 0.625 }}>
                Passwort zurücksetzen
              </Typography>
              <Typography
                variant='body1'
                component='p'
                sx={{ textAlign: 'center', my: 1.25, color: 'text.secondary' }}
              >
                Bitte gib deinen Benutzernamen, deine E-Mail-Adresse oder deinen Vor- und Nachnamen
                ein
              </Typography>
            </Grid>
          </>
        )}

        {/* SUCCESS MESSAGE */}
        {successMessage && (
          <Stack style={{ alignItems: 'center', width: '100%' }}>
            <Alert severity='success' sx={{ marginY: '10px' }}>
              {translateSuccessMessage(successMessage)}
            </Alert>
          </Stack>
        )}

        {/* ERROR */}
        {error && (
          <Stack style={{ alignItems: 'center', width: '100%' }}>
            <Alert severity='error' sx={{ marginY: '10px' }}>
              {error}
            </Alert>
          </Stack>
        )}

        {!successMessage && !error ? (
          <>
            {/* INPUT */}
            <Grid xs={12}>
              <TextField
                label='Benutzername, E-Mail oder Vor- und Nachname'
                variant='outlined'
                value={input}
                onChange={e => setInput(e.target.value)}
                fullWidth
                placeholder='z.B. MaxMustermann1, max@example.com oder Max Mustermann'
              />
            </Grid>

            <Grid xs={12} sx={{ marginTop: '20px' }} container>
              {/* BACK TO LOGIN BUTTON */}
              <Grid xs={12} sm={6} sx={{ textAlign: 'left' }}>
                <Link to='/' style={{ textDecoration: 'none' }}>
                  <Button type='button' sx={{ maxWidth: '200px' }}>
                    <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: '5px' }} />
                    Zurück zum Login
                  </Button>
                </Link>
              </Grid>
              {/* SUBMIT BUTTON */}
              <Grid xs={12} sm={6} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  type='submit'
                  onClick={handleSubmit}
                  disabled={isLoading || !input.trim()}
                  sx={{ maxWidth: '200px' }}
                >
                  {isLoading ? 'Wird gesendet...' : 'E-Mail senden'}
                  <FontAwesomeIcon icon={faArrowRight} style={{ marginLeft: '5px' }} />
                </Button>
              </Grid>
            </Grid>
          </>
        ) : (
          <>
            {/** Back to login button */}
            <Grid xs={12} sx={{ textAlign: 'center' }}>
              <Link to='/' style={{ textDecoration: 'none' }}>
                <Button type='button' sx={{ maxWidth: '200px' }}>
                  Zurück zum Login
                </Button>
              </Link>
            </Grid>
          </>
        )}
      </form>
    </Grid>
  );
}

export default RequestPasswordReset;
